export default "__VITE_ASSET__oGkXW1Oo__"